module.exports = __webpack_public_path__ + "img/san-carlos-marina.c00ffa7b.png";